import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import vueMoment from 'vue-moment'
import VueNumerals from 'vue-numerals'
import VueLoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
// import i18n from './i18n'

import VueDaumPostcode from "vue-daum-postcode"

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import VueClipboard from 'vue-clipboard2'

Vue.component('LoadingOverlay', VueLoadingOverlay);

// import ElementUI from 'element-ui';
// import { ElementTiptapPlugin } from 'element-tiptap';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-tiptap/lib/index.css';
// Vue.use(ElementUI);
// Vue.use(ElementTiptapPlugin, { lang: "ko" });

Vue.use(VueSidebarMenu)
Vue.config.devtools = true;
Vue.use(vueMoment)
Vue.use(VueNumerals)
Vue.config.productionTip = false
Vue.use(VueDaumPostcode, {
  name: "daum-post"
})
Vue.use(Viewer)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  vuetify,
  // i18n,
  render: h => h(App)
}).$mount('#app')
